import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-wrapper"},[_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c(VTextField,_vm._g(_vm._b({staticClass:"input",attrs:{"solo":"","hide-details":""}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }